import { createBrowserRouter } from 'react-router-dom';
import { directorRoutes } from '@teetsh/app/src/router/directorRoutes';
import { teacherRoutes } from '@teetsh/app/src/router/teacherRoutes';
import { unauthRoutes } from '@teetsh/app/src/router/unauthRoutes';

export const router = createBrowserRouter([
  ...unauthRoutes,
  ...directorRoutes,
  ...teacherRoutes,
]);
